<div class="assignment-role-matrix-container">
  <div class="matrix-toolbar">
    <mat-form-field appearance="outline" class="matrix-search">
      <mat-label>Search users</mat-label>
      <input matInput placeholder="Type to filter users" (input)="onUserFilterInput($event)" />
    </mat-form-field>
    <app-role-toggle-filter [value]="roleFilter" (valueChange)="onRoleFilterChange($event)"></app-role-toggle-filter>
  </div>

  <div class="table-container">
    @let vm = vm$ | async;
    <app-project-role-matrix
      [vm]="vm"
      [hasRole]="hasAssignmentRole.bind(this)"
      [getRoleIcon]="getRoleIcon.bind(this)"
      [toggleRole]="toggleAssignmentRole.bind(this)"
    ></app-project-role-matrix>
  </div>
</div>
